import { rest } from 'msw';
import { API_REST_URL } from "config/variables";
import { reportsMock } from '../reportsCenter.mock';

const getReports = rest.post(
    `${API_REST_URL}/reports-list/:clientId/:userId`,
    (req, res, ctx) => {
        return res(
            ctx.delay(2000),
            ctx.json({
                data: {
                    reports: reportsMock,
                    count: reportsMock.length + 5
                },
                status: 'success'
            }
            ),
        );
    },
);

const deleteReport = rest.delete(
    `${API_REST_URL}/reports-list/:clientId/:userId/:reportId`,
    (req, res, ctx) => {
        return res(
            ctx.json({
                status: 'success'
            }
            ),
        );
    },
);

export const reportsCenterHandlers = [getReports, deleteReport]